var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"resize",rawName:"v-resize"}],ref:"scheme-container",staticClass:"scheme",on:{"resize":_vm.draw}},[_c('canvas',{ref:"scheme-canvas"})])}
var staticRenderFns = []

export { render, staticRenderFns }